import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { formatPercent } from "../charts/format";
import StepFunnel from "./StepFunnel";

// O funil da visao geral (spec do redesign, R4.3): entre cada par, a passagem do passo anterior em
// destaque. Num chat embutido comeca nas conversas. Uma passagem acima de 100% nao se mostra: duas
// conversas numa abertura, ou historico reconstruido antes de as aberturas se contarem (entrega 6).
const FunnelSteps = ({ funnel }) => {
  const { translate, language } = useLanguage();
  const keys = funnel.starts_at === "page_views" ? ["page_views", "opens", "conversations"] : ["conversations"];
  const steps = [...keys.map((key) => ({ key, value: funnel[key] })), { key: "two_or_more", value: funnel.conversations_two_or_more_messages }].map((step, index, all) => {
    const previous = index > 0 ? all[index - 1].value : null;
    const rate = previous && step.value <= previous ? formatPercent((100 * step.value) / previous, language) : null;
    return { ...step, label: translate(`analyticsFunnel.${step.key}`), rate, rateLabel: rate && translate(`analyticsFunnelRate.${step.key}`) };
  });
  return <StepFunnel title={translate("analyticsFunnel")} note={funnel.starts_at === "conversations" ? translate("analyticsFunnelDockedNote") : null} steps={steps} />;
};

export default FunnelSteps;
